// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    CustomerAutoDeliveryDtoModel,
    updateAutoDelivery as updateAutoDeliveryService,
} from "@guestsupply/App/Services/AutoDelivery";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

export type AutoDeliveryProps = {
    productId: string;
};
type HandlerType = ApiHandler<
    CustomerAutoDeliveryDtoModel & HasOnSuccess & HasOnError<string>,
    ServiceResult<CustomerAutoDeliveryDtoModel> & {
        errorMessage?: string;
    }
>;

export const CallUpdateAutoDeliveryApi: HandlerType = async props => {
    const {
        billToId,
        productId,
        shipToId,
        carrierId,
        shipViaId,
        purchaseOrderNo,
        qty,
        uom,
        startDate,
        repetition,
        isCancelled,
        shipBranchName,
        nextDeliveryDate,
        contactEmail,
    } = props.parameter;

    const updateAutoDelivryResult = await updateAutoDeliveryService({
        billToId,
        productId,
        shipToId,
        carrierId,
        shipViaId,
        purchaseOrderNo,
        qty,
        uom,
        startDate,
        repetition,
        isCancelled,
        shipBranchName,
        nextDeliveryDate,
        contactEmail,
    });
    props.apiResult = updateAutoDelivryResult;
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};
export const chain = [CallUpdateAutoDeliveryApi, ExecuteOnSuccessCallback];

const updateAutoDelivery = createHandlerChainRunner(chain, "updateAutoDelivery");
export default updateAutoDelivery;
